<template>
    <img class="logo-pastel" alt="pastel logo" src="../assets/logo-pastel.png">
</template>

<script>

export default {
  name: 'ImgLogo',
}
</script>

<style>
  .logo-pastel {
    border-radius: 50%;
  }
</style>>
